
































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import ImageComponent from '@components/001-ImageComponent/ImageComponent.vue';
import LinkComponent from '@components/base/LinkComponent.vue';
import IProductPiece from '@frontend/types/base/IProductPiece';
import IProductPack from '@frontend/types/base/IProductPack';
import IconTextLink from '@components/005-IconTextLink/IconTextLink.vue';
import BaseSlider, { IBaseSliderOptions } from '@components/base/BaseSlider';
import gsap from 'gsap';
import ILink from '@frontend/types/base/ILink';
import { createBackgroundColorStylesFor } from '@frontend/functions/colorStyles';

@Component({
	components: {
		LinkComponent,
		ImageComponent,
		ButtonComponent,
		IconTextLink
	}
})
export default class InspirationOverlay extends Vue {
	@Prop(Object)
	protected readonly productPiece!: IProductPiece;

	@Prop(Array)
	protected readonly relatedProducts!: IProductPack[];

	@Prop(Object)
	protected readonly pickAndMixLink?: ILink;

	protected baseSliderPromise?: any;

	protected BaseSlider?: any;

	protected productsSlider?: BaseSlider;

	protected mounted(): void {
		this.baseSliderPromise = this.loadBaseSlider();
		const closeButton = (this.$refs.close as Vue).$el as HTMLElement;
		closeButton.focus();
		if (this.tileCount > 1) {
			this.initProductSlider();
		}

		this.$nextTick(() => {
			this.playAnimation();
		});

		createBackgroundColorStylesFor(this.relatedProducts.map(product => product.primaryBackgroundColor));
	}

	protected destroyed(): void {
		// small workaround, otherwise Flickity gets destroyed before leave animation resulting in flickering layout
		setTimeout(() => {
			if (this.productsSlider) {
				this.productsSlider.destroy();
			}
		}, 400);
	}

	protected async loadBaseSlider(): Promise<void> {
		this.BaseSlider = (await import('@components/base/BaseSlider')).default;
	}

	private async initProductSlider(): Promise<void> {
		const productSliderOptions: IBaseSliderOptions = {
			flickityOptions: {
				groupCells: true,
				cellAlign: 'center',
				pageDots: true,
				contain: true,
				wrapAround: false,
				watchCSS: true
			}
		};

		await this.baseSliderPromise;
		this.productsSlider = new this.BaseSlider(this.$refs.products as HTMLElement, productSliderOptions);
	}

	/**
	 * if an additional tile and/or the pickAndMix teaser is given, add it to the tile count of products
	 * this is necessary for styling reasons for handling the layout with CSS more easily
	 */
	protected get tileCount(): number {
		let count = this.productPiece.relatedProducts.length;

		if (this.pickAndMixLink) count++;
		if (this.productPiece.additionalTile) count++;

		return count;
	}

	protected playAnimation(): void {
		gsap.from((this.$refs.pieceImage as Vue).$el, {
			delay: 0.5,
			scale: 0.4,
			opacity: 0,
			duration: 0.4,
			ease: 'back.out(2)'
		});

		gsap.from('.m-inspiration-overlay__product-image', {
			delay: 0.9,
			opacity: 0,
			duration: 0.4,
			stagger: 0.15
		});
	}
}
